<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<div
  class="row m-0 mt-2"
  *ngIf="
    PageAcess &&
    PageAcess !== undefined &&
    PageAcess !== '' &&
    PageAcess !== null &&
    PageAcess[0].View == 1
  "
>
  <form
    #f="ngForm"
    class="col-md-12 formborder overflow-hidden"
    novalidate
  >
    <div>
      <div class="row m-0" *ngIf="isNew">
        <div class="col-md-3 p-1">
          <span class="required-lable"> Branch </span>
          <select
            name="Branch_Id"
            (change)="getAppNo_AND_LoanNo()"
            id="Branch_Id"
            #refBranch_Id="ngModel"
            required
            [disabled]="loanInfoModel.AppInfo.isDisable"
            [ngClass]="{
              'is-invalid': f.submitted && refBranch_Id.invalid,
              'alert-warning':
                refBranch_Id.invalid &&
                (refBranch_Id.dirty ||
                  refBranch_Id.touched ||
                  refBranch_Id.untouched)
            }"
            [(ngModel)]="loanInfoModel.AppInfo.Branch_Id"
            class="form-control input-text-css"
          >
            <option value="">Select Branch</option>
            <option
              *ngFor="let branch of BranchesList"
              [value]="branch.BranchId"
            >
              {{ branch.Branch_Name }}
            </option>
          </select>
        </div>
        <div class="col-md-3 p-1 d-none">
          <span> Application No </span>
          <input
            name="ApplicationNo"
            id="ApplicationNo"
            #refApplicationNo="ngModel"
            [disabled]="loanInfoModel.AppInfo.isDisable"
            [(ngModel)]="loanInfoModel.AppInfo.ApplicationNo"
            readonly
            placeholder="ApplicationNo"
            class="form-control input-text-css"
          />
        </div>
        <div class="col-md-3 p-1">
          <span class="required-lable"> Application Date </span>
          <div class="datepicker_feild">
            <input
              [matDatepicker]="picker"
              dateConvert
              placeholder="DD/MM/YYYY"
              name="ApplicationDate"
              id="ApplicationDate"
              #refApplicationDate="ngModel"
              required
              [disabled]="loanInfoModel.AppInfo.isDisable"
              [ngClass]="{
                'is-invalid': f.submitted && refApplicationDate.invalid,
                'alert-warning':
                  refApplicationDate.invalid &&
                  (refApplicationDate.dirty ||
                    refApplicationDate.touched ||
                    refApplicationDate.untouched)
              }"
              [(ngModel)]="loanInfoModel.AppInfo.ApplicationDate"
              class="form-control input-text-css"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <!-- <input
            name="ApplicationDate"
            id="ApplicationDate"
            #refApplicationDate="ngModel"
            required
            [disabled]="loanInfoModel.AppInfo.isDisable"
            [ngClass]="{
              'is-invalid': f.submitted && refApplicationDate.invalid,
              'alert-warning':
                refApplicationDate.invalid &&
                (refApplicationDate.dirty ||
                  refApplicationDate.touched ||
                  refApplicationDate.untouched)
            }"
            [(ngModel)]="loanInfoModel.AppInfo.ApplicationDate"
            value="{{
              loanInfoModel.AppInfo.ApplicationDate | date : 'dd/MM/yyyy'
            }}"
            placeholder="DD/MM/YYYY"
            class="form-control input-text-css"
            [maxDate]="currentDate"
            [(bsValue)]="loanInfoModel.AppInfo.ApplicationDate"
            bsDatepicker
          /> -->
        </div>
        <div class="col-md-3 p-1">
          <span class="required-lable"> Loan Product </span>
          <select
            name="LoanProduct_Id"
            id="LoanProduct_Id"
            #refLoanProduct_Id="ngModel"
            required
            [disabled]="loanInfoModel.AppInfo.isDisable"
            [ngClass]="{
              'is-invalid': f.submitted && refLoanProduct_Id.invalid,
              'alert-warning':
                refLoanProduct_Id.invalid &&
                (refLoanProduct_Id.dirty ||
                  refLoanProduct_Id.touched ||
                  refLoanProduct_Id.untouched)
            }"
            [(ngModel)]="loanInfoModel.AppInfo.LoanProduct_Id"
            class="form-control input-text-css"
          >
            <option value="">Select Products</option>
            <ng-container *ngFor="let productg of ProductList">
              <option
                *ngIf="productg.Product_IsActive == true"
                [value]="productg.ProductId"
              >
                {{ productg.Product }}
              </option>
            </ng-container>
          </select>
        </div>
        <div class="col-md-3 p-1">
          <span class="required-lable"> Branch Head </span>
          <select
            name="SelectBranchHead"
            id="SelectBranchHead"
            #refSelectBranchHead="ngModel"
            required
            [ngClass]="{
              'is-invalid': f.submitted && refSelectBranchHead.invalid,
              'alert-warning':
                refSelectBranchHead.invalid &&
                (refSelectBranchHead.dirty ||
                  refSelectBranchHead.touched ||
                  refSelectBranchHead.untouched)
            }"
            [(ngModel)]="loanInfoModel.LoanInfo.SelectBranchHead"
            class="form-control input-text-css"
          >
            <option value="">Select Branch Head</option>
            <option *ngFor="let head of branchHeadData" [value]="head.EmpId">
              {{ head.Emp_FirstName + " " + head.Emp_LastName }}
            </option>
          </select>
        </div>
      </div>
      <ng-container *ngIf="loanInfoModel.LoanInfo.isEdit">
        <div class="row m-0">
          <div class="col-md-3 p-1" *ngIf="!isNew">
            <span class="required-lable"> Application Date </span>
            <div class="datepicker_feild">
              <input
                [matDatepicker]="picker2"
                dateConvert
                placeholder="DD/MM/YYYY"
                name="ApplicationDate"
                id="ApplicationDate"
                #refApplicationDate="ngModel"
                required
                [disabled]="loanSummary.LoanNo != null"
                class="form-control input-text-css"
                [ngClass]="{
                  'is-invalid': f.submitted && refApplicationDate.invalid,
                  'alert-warning':
                    refApplicationDate.invalid &&
                    (refApplicationDate.dirty ||
                      refApplicationDate.touched ||
                      refApplicationDate.untouched)
                }"
                [(ngModel)]="loanInfoModel.AppInfo.ApplicationDate"
                [max]="currentDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker2"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </div>
          </div>
          <div class="col-md-3 p-1">
            <span class="required-lable"> Source Type </span>
            <select
              name="SelectSourceType"
              id="SelectSourceType"
              #refSelectSourceType="ngModel"
              required
              [ngClass]="{
                'is-invalid': f.submitted && refSelectSourceType.invalid,
                'alert-warning':
                  refSelectSourceType.invalid &&
                  (refSelectSourceType.dirty ||
                    refSelectSourceType.touched ||
                    refSelectSourceType.untouched)
              }"
              (change)="Get_PartnerForDropdown()"
              [(ngModel)]="loanInfoModel.LoanInfo.SelectSourceType"
              class="form-control input-text-css"
            >
              <option value="">Select Source Type</option>
              <option
                *ngFor="let lead of leadSourceDropdown"
                [value]="lead.Lead_Source"
              >
                {{ lead.Lead_Source_DisplayName }}
              </option>
            </select>
          </div>
          <ng-container
            *ngIf="
              loanInfoModel.LoanInfo.SelectSourceType == 'Agent' ||
              loanInfoModel.LoanInfo.SelectSourceType == 'DSA' ||
              loanInfoModel.LoanInfo.SelectSourceType == 'Dealer' ||
              loanInfoModel.LoanInfo.SelectSourceType == 'Sales Executive' ||
              loanInfoModel.LoanInfo.SelectSourceType ==
                'Telecaller Executive' ||
              loanInfoModel.LoanInfo.SelectSourceType == 'Marketing Executive'
            "
          >
            <div class="col-md-3 p-1">
              <span class="required-lable"> Source Name</span>
              <select
                name="LeadSourceName"
                id="LeadSourceName"
                #refLeadSourceName="ngModel"
                required
                [ngClass]="{
                  'is-invalid': f.submitted && refLeadSourceName.invalid,
                  'alert-warning':
                    refLeadSourceName.invalid &&
                    (refLeadSourceName.dirty ||
                      refLeadSourceName.touched ||
                      refLeadSourceName.untouched)
                }"
                [(ngModel)]="loanInfoModel.LoanInfo.LeadSourceName"
                class="form-control input-text-css"
              >
                <option value="">Select Lead Reference</option>
                <option
                  *ngFor="let partner of partnerDropdown"
                  [value]="partner.PartnerId"
                >
                  {{ partner.Partner_Name }}
                </option>
              </select>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              loanInfoModel.LoanInfo.SelectSourceType == 'Reference' ||
              loanInfoModel.LoanInfo.SelectSourceType == 'Social Media'
            "
          >
            <div class="col-md-3 p-1">
              <span> Source Name</span>
              <input
                type="text"
                #refLeadReference="ngModel"
                [(ngModel)]="loanInfoModel.LoanInfo.LeadReference"
                placeholder="Lead Reference"
                name="LeadReference"
                id="LeadReference"
                class="form-control input-text-css"
              />
            </div>
          </ng-container>

          <div class="col-md-3 p-1">
            <span class="required-lable"> Source Area</span>
            <select
              name="SelectSourceArea"
              id="SelectSourceArea"
              #refSelectSourceArea="ngModel"
              [(ngModel)]="loanInfoModel.LoanInfo.SelectSourceArea"
              class="form-control input-text-css"
              required
              [ngClass]="{
                'is-invalid': f.submitted && refSelectSourceArea.invalid,
                'alert-warning':
                  refSelectSourceArea.invalid &&
                  (refSelectSourceArea.dirty ||
                    refSelectSourceArea.touched ||
                    refSelectSourceArea.untouched)
              }"
            >
              <option value="0">Select Source Area</option>
              <ng-container *ngFor="let area of areaData">
                <option
                  *ngIf="area.Type.trim() == 'Source Area'"
                  [value]="area.Int_Id"
                >
                  {{ area.Area_Name }}
                </option>
              </ng-container>
            </select>
          </div>

          <div class="col-md-3 p-1">
            <span class="required-lable"> Sales Executive</span>
            <select
              name="SalesExecutive"
              id="SalesExecutive"
              #refSalesExecutive="ngModel"
              required
              [ngClass]="{
                'is-invalid': f.submitted && refSalesExecutive.invalid,
                'alert-warning':
                  refSalesExecutive.invalid &&
                  (refSalesExecutive.dirty ||
                    refSalesExecutive.touched ||
                    refSalesExecutive.untouched)
              }"
              [(ngModel)]="loanInfoModel.LoanInfo.SalesExecutive"
              class="form-control input-text-css"
            >
              <option value="">Select Sales Executive</option>
              <option
                *ngFor="let collection of SalesExecutiveData"
                [value]="collection.EmpId"
              >
                {{ collection.EmpName }}
              </option>
            </select>
          </div>

          <div class="col-md-3 p-1">
            <span> Collection Executive</span>
            <select
              name="CollectionExecutive"
              id="CollectionExecutive"
              #refCollectionExecutive="ngModel"
              [(ngModel)]="loanInfoModel.LoanInfo.CollectionExecutive"
              class="form-control input-text-css"
            >
              <option value="0">Select Collection Executive</option>
              <option
                *ngFor="let collection of CollectionExecutiveData"
                [value]="collection.EmpId"
              >
                {{ collection.Emp_FirstName }}
              </option>
            </select>
          </div>
          <div class="col-md-3 p-1">
            <span> Collection Area</span>
            <select
              name="SelectArea"
              id="SelectArea"
              (change)="changeArea()"
              #refSelectArea="ngModel"
              [(ngModel)]="loanInfoModel.LoanInfo.SelectArea"
              class="form-control input-text-css"
            >
              <option value="0">Select Collection Area</option>
              <!-- <option *ngFor="let area of areaData" [value]="area.Int_Id"> {{area.Area_Name}} </option> -->
              <ng-container *ngFor="let area of areaData">
                <option
                  *ngIf="area.Type.trim() == 'Collection Area'"
                  [value]="area.Int_Id"
                >
                  {{ area.Area_Name }}
                </option>
              </ng-container>
            </select>
          </div>
          <div class="col-md-3 p-1">
            <span> Collection Sub Area</span>
            <select
              name="SelectSubarea"
              id="SelectSubarea"
              #refSelectSubarea="ngModel"
              [(ngModel)]="loanInfoModel.LoanInfo.SelectSubarea"
              class="form-control input-text-css"
            >
              <option value="0">Select Collection SubArea</option>
              <option
                *ngFor="let subarea of subAreaData"
                [value]="subarea.Int_Id"
              >
                {{ subarea.Sub_Area_Name }}
              </option>
            </select>
          </div>
          <div
            class="col-md-3 p-1"
            *ngIf="loanSummary.LoanNo != '' && loanSummary.LoanNo != undefined"
          >
            <span> CRC Agency Loan Type(Individual) </span>
            <select
              name="SelectCRCType"
              id="SelectCRCType"
              #refSelectCRCType="ngModel"
              [(ngModel)]="loanInfoModel.LoanInfo.CRC_LoanType"
              [ngClass]="{
                'is-invalid': f.submitted && refSelectCRCType.invalid,
                'alert-warning':
                  refSelectCRCType.invalid &&
                  (refSelectCRCType.dirty ||
                    refSelectCRCType.touched ||
                    refSelectCRCType.untouched)
              }"
              [disabled]="inViewMode"
              class="form-control input-text-css"
              required
            >
              <option value="0">Select Loan Type</option>
              <option *ngFor="let Type of CRC_Type" [value]="Type.Id">
                {{ Type.Value + "[" + Type.Code + "]" }}
              </option>
            </select>
          </div>
          <div
            class="col-md-3 p-1"
            *ngIf="loanSummary.LoanNo != '' && loanSummary.LoanNo != undefined && loanSummary.IsAnyCustomerFirm == 1"
          >
            <span> CRC Agency Loan Type(Non-Individual) </span>
            <select
              name="SelectCRCTypeNI"
              id="SelectCRCTypeNI"
              #refSelectCRCTypeNI="ngModel"
              [(ngModel)]="loanInfoModel.LoanInfo.CRC_LoanType_NonIndividual"
              [ngClass]="{
                'is-invalid': f.submitted && refSelectCRCTypeNI.invalid,
                'alert-warning':
                  refSelectCRCTypeNI.invalid &&
                  (refSelectCRCTypeNI.dirty ||
                    refSelectCRCTypeNI.touched ||
                    refSelectCRCTypeNI.untouched)
              }"
              [disabled]="inViewMode"
              class="form-control input-text-css"
              required
            >
              <option value="0">Select Loan Type</option>
              <option *ngFor="let Type of CRC_Type_Non_Individual" [value]="Type.Id">
                {{ Type.Value + "[" + Type.Code + "]" }}
              </option>
            </select>
          </div>

          <div
            class="col-md-3 p-1"
            *ngIf="loanSummary.LoanNo != '' && loanSummary.LoanNo != undefined"
          >
            <span> SUIT FILED STATUS </span>
            <select
              name="Select_SUITFILEDSTATUS"
              id="Select_SUITFILEDSTATUS"
              #refSelect_SUITFILEDSTATUS="ngModel"
              [(ngModel)]="loanInfoModel.LoanInfo.SUITFILEDSTATUS"
              [disabled]="inViewMode"
              class="form-control input-text-css"
            >
              <option value="0">Select SUIT FILED STATUS</option>
              <option
                *ngFor="let Type of SUITFILEDSTATUSList"
                [value]="Type.Id"
              >
                {{ Type.Value }}
              </option>
            </select>
          </div>

          <div
            class="col-md-3 p-1"
            *ngIf="loanSummary.LoanNo != '' && loanSummary.LoanNo != undefined"
          >
            <span> Loan Segment </span>
            <select
              name="select_Loan_Segment"
              id="select_Loan_Segment"
              #refselect_Loan_Segment="ngModel"
              [(ngModel)]="loanInfoModel.LoanInfo.Loan_Segment"
              [disabled]="inViewMode"
              class="form-control input-text-css"
            >
              <option value="0">Select Loan Segment</option>

              <option *ngFor="let Type of loanSegmentList" [value]="Type.Id">
                {{ Type.Value }}
              </option>
            </select>
          </div>

          <div class="col-md-3"
          *ngIf="loanSummary.LoanNo != '' && loanSummary.LoanNo != undefined">
            <span >OD_Interest</span>
                <input type="text" #refODInterest="ngModel" [(ngModel)]="loanInfoModel.LoanInfo.OD_Interest"
                placeholder="OD Interest"  maxlength="15" appTwoDigitDecimaNumber name="OD_Interest"
                id="OD_Interest" class="form-control input-text-css mt-1" >
           </div>
           <div class="col-md-3"
          *ngIf="loanSummary.LoanNo != '' && loanSummary.LoanNo != undefined && loanSummary.Loan_Acc_Type == 'Channel'">
            <span >Channel Partner LoanAcNo</span>
                <input type="text" #refChannel_Partner_LoanAcNo="ngModel" [(ngModel)]="loanInfoModel.LoanInfo.Channel_Partner_LoanAcNo"
                placeholder="Channel Partner LoanAcNo"   name="Channel_Partner_LoanAcNo"
                id="Channel_Partner_LoanAcNo" class="form-control input-text-css mt-1" >
           </div>
          <div
            class="col-md-2 mt-3"
            *ngIf="loanSummary.LoanNo != '' && loanSummary.LoanNo != undefined"
          >
            <mat-checkbox
              name="IsSMSAllow"
              [(ngModel)]="loanInfoModel.LoanInfo.IsSMSAllow"
              class="mt-3"
            >
              Sent Text SMS
            </mat-checkbox>
          </div>
          <div
            class="col-md-2 mt-3"
            *ngIf="loanSummary.LoanNo != '' && loanSummary.LoanNo != undefined"
          >
            <mat-checkbox
              name="IsEmail_Allow"
              [(ngModel)]="loanInfoModel.LoanInfo.IsEmail_Allow"
              class="mt-3"
            >
              Sent Text Email
            </mat-checkbox>
          </div>
          <div
            class="col-md-2 mt-3"
            *ngIf="loanSummary.LoanNo != '' && loanSummary.LoanNo != undefined"
          >
            <mat-checkbox
              name="IsWhatsApp_Allow"
              [(ngModel)]="loanInfoModel.LoanInfo.IsWhatsApp_Allow"
              class="mt-3"
            >
              Sent Text on WhatsApp
            </mat-checkbox>
          </div>
          <div
            class="col-md-2 mt-3"
            *ngIf="loanSummary.LoanNo != '' && loanSummary.LoanNo != undefined"
          >
            <mat-checkbox
              name="IsCibil"
              [(ngModel)]="loanInfoModel.LoanInfo.IsCibil"
              class="mt-3"
            >
              Include in CIBIL Report
            </mat-checkbox>
          </div>

          <div class="col-md-12 p-1">
            <span class="required-lable"> Loan Purpose </span>
            <textarea
              [(ngModel)]="loanInfoModel.LoanInfo.LoanPurpose"
              rows="3"
              maxlength="150"
              #refLoanPurpose="ngModel"
              required
              [ngClass]="{
                'is-invalid': f.submitted && refLoanPurpose.invalid,
                'alert-warning':
                  refLoanPurpose.invalid &&
                  (refLoanPurpose.dirty ||
                    refLoanPurpose.touched ||
                    refLoanPurpose.untouched)
              }"
              placeholder="Loan Purpose"
              name="LoanPurpose"
              id="LoanPurpose"
              class="form-control input-text-css"
            ></textarea>
          </div>
          <app-add-customer-info
            [TypeFrom]="TypeFrom"
            [loan_Summary]="loanSummary"
            [SelectedProductId]="loanInfoModel.AppInfo.LoanProduct_Id"
            (close)="GetData($event)"
            [digilockerSdk1]="digilockerSdk1"
            [sdkEventData]="sdkEventData"
            (click)="addCustomerLink()"
            [index]="999978465123102"
            [Heading]="'Add'"
            *ngIf="showAddCustomerButton"
          >
            <button
              type="button"
              class="mt-3 btn font-size-12 button-btn"
              [disabled]="!f.form.valid"
            >
              Add Customer
            </button>
          </app-add-customer-info>
        </div>
      </ng-container>

      <ng-container *ngIf="!loanInfoModel.LoanInfo.isEdit">
        <div class="m-0 clientOuterDiv" *ngIf="loanInfoModel.LoanInfo">
          <!-- Left Column: Borrower Profile Card -->
          <div class="leftPart">
            <div class="profile-avatar-container" (click)="ProfilePicFullmodel()">
              <img
                src="{{ CustomerPicDetail }}"
                alt="Profile Pic"
              />
            </div>

            <div class="d-flex flex-column align-items-center">
              <div class="profile-name">{{ customerData?.Customer }}</div>
              <div class="profile-relation" *ngIf="customerData?.Relation_Name">{{ customerData?.Relation_Name }}</div>
              <div class="cif-badge" *ngIf="customerData?.CIF_No || customerData?.CIFNo || customerData?.Cif_No || customerData?.CifNo || loanSummary?.CIF_No || loanSummary?.CIFNo || loanSummary?.Cif_No || loanSummary?.CifNo">
                CIF: {{ customerData?.CIF_No || customerData?.CIFNo || customerData?.Cif_No || customerData?.CifNo || loanSummary?.CIF_No || loanSummary?.CIFNo || loanSummary?.Cif_No || loanSummary?.CifNo }}
              </div>
            </div>

            <div class="profile-info-list">
              <!-- Mobile No -->
              <div class="profile-info-item">
                <i class="fa fa-phone info-icon"></i>
                <div class="info-content">
                  <div class="info-label">Mobile No.</div>
                  <div class="info-value">
                    <span *ngIf="currentUser.IsMaskingMobile">{{ customerData?.PhoneNo | mask }}</span>
                    <span *ngIf="!currentUser.IsMaskingMobile">{{ customerData?.PhoneNo }}</span>
                    <i
                      *ngIf="customerData?.PhoneNoIsVerified === true"
                      class="fa fa-check-circle ml-2"
                      style="color: green"
                    ></i>
                  </div>
                </div>
              </div>

              <!-- Email ID -->
              <div class="profile-info-item">
                <i class="fa fa-envelope info-icon"></i>
                <div class="info-content">
                  <div class="info-label">Email Id</div>
                  <div class="info-value">
                    <span *ngIf="currentUser.IsMaskingMobile">{{ customerData?.Customer_Email ? (customerData?.Customer_Email | emailmask) : "Nil" }}</span>
                    <span *ngIf="!currentUser.IsMaskingMobile">{{ customerData?.Customer_Email ? customerData?.Customer_Email : "Nil" }}</span>
                  </div>
                </div>
              </div>

              <!-- Present Address -->
              <div class="profile-info-item">
                <i class="fa-solid fa-location-dot info-icon"></i>
                <div class="info-content">
                  <div class="info-label">Present Address</div>
                  <div class="info-value">
                    <span
                      *ngIf="
                        CustomerAddress?.Present_LatLong != '' &&
                        CustomerAddress?.Present_LatLong != null &&
                        CustomerAddress?.Present_LatLong != ','
                      "
                    >
                      {{ CustomerAddress?.Present_Address }}
                      <a
                        target="_blank"
                        [href]="'http://maps.google.com/maps?q=' + CustomerAddress?.Present_LatLong"
                        title="Google Maps"
                      >
                        <i class="fa-solid fa-up-right-from-square"></i>
                      </a>
                    </span>
                    <span
                      *ngIf="
                        CustomerAddress?.Present_LatLong == '' ||
                        CustomerAddress?.Present_LatLong == null
                      "
                    >
                      {{ CustomerAddress?.Present_Address }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Permanent Address -->
              <div class="profile-info-item">
                <i class="fa-solid fa-house-chimney info-icon"></i>
                <div class="info-content">
                  <div class="info-label">Permanent Address</div>
                  <div class="info-value">
                    <span
                      *ngIf="
                        CustomerAddress?.Permanent_LatLong != '' &&
                        CustomerAddress?.Permanent_LatLong != null &&
                        CustomerAddress?.Permanent_LatLong != ','
                      "
                    >
                      {{ CustomerAddress?.Permanent_Address }}
                      <a
                        target="_blank"
                        [href]="'http://maps.google.com/maps?q=' + CustomerAddress?.Permanent_LatLong"
                        title="Google Maps"
                      >
                        <i class="fa-solid fa-up-right-from-square"></i>
                      </a>
                    </span>
                    <span
                      *ngIf="
                        CustomerAddress?.Permanent_LatLong == '' ||
                        CustomerAddress?.Permanent_LatLong == null ||
                        CustomerAddress?.Permanent_LatLong == ','
                      "
                    >
                      {{ CustomerAddress?.Permanent_Address }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="profile-actions">
              <button
                type="button"
                (click)="viewCustomerDetails()"
                class="btn-outline-brand"
                [class.spinner]="loading"
                [disabled]="!f.form.valid"
              >
                View Details
              </button>

              <button
                type="button"
                (click)="viewBasicInfo()"
                class="btn-brand-filled"
                [class.spinner]="loading"
                [disabled]="!f.form.valid"
              >
                Basic Info
              </button>
            </div>
          </div>

          <!-- Right Column: Details Cards -->
          <div class="rightPart">
            <!-- Loan Details Card -->
            <div class="details-card">
              <div class="card-header-container">
                <h3 class="card-title-text">Loan Details</h3>
                <button
                  type="button"
                  (click)="loanInfoModel.LoanInfo.isEdit = !loanInfoModel.LoanInfo.isEdit"
                  *ngIf="
                    !loanInfoModel.LoanInfo.isEdit &&
                    PageAcess &&
                    PageAcess[0].Edit == 1 &&
                    !loanSummary.CloseDate
                  "
                  class="btn font-size-12 button-btn btn-outline-brand py-1 px-3"
                  style="border-radius: 0.375rem;"
                >
                  Edit
                </button>
              </div>

              <div class="details-grid">
                <div class="details-field">
                  <span class="field-label">Loan No</span>
                  <span class="field-value">{{ loanSummary.LoanNo || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Loan Date</span>
                  <span class="field-value">{{ loanSummary.LoanDate || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Application No</span>
                  <span class="field-value">{{ loanSummary.ApplicationNo || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Borrower</span>
                  <span class="field-value">{{ loanSummary.Customer || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Branch</span>
                  <span class="field-value">{{ loanSummary.Branch || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Loan Amount</span>
                  <span class="field-value">{{ loanSummary.LoanAmount || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Loan Acc Type</span>
                  <span class="field-value">{{ loanSummary.Loan_Acc_Type || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Product</span>
                  <span class="field-value">{{ loanSummary.Product || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Product Category</span>
                  <span class="field-value">{{ loanSummary.Product_Category || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Installment Amount</span>
                  <span class="field-value">{{ loanSummary.EMIAmount || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Expiry Date</span>
                  <span class="field-value">{{ loanSummary.ExpiryDate || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Close Date</span>
                  <span class="field-value">{{ loanSummary.CloseDate || '-' }}</span>
                </div>
                <div class="details-field" *ngIf="loanSummary.Loan_Acc_Type == 'Channel'">
                  <span class="field-label">Channel Partner Loan Acno</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.Channel_Partner_LoanAcno || '-' }}</span>
                </div>

                <!-- <div class="row">
                  <div
                    class="col-md-3"
                    *ngIf="
                      loanSummary.LoanNo != null && loanSummary.LoanNo != ''
                    "
                  >
                    <h6>Cibil Allow</h6>
                    <p>{{ loanInfoModel.LoanInfo.IsCibil ? "Yes" : "No" }}</p>
                  </div>
                  <div
                    class="col-md-3"
                    *ngIf="loanInfoModel.LoanInfo.NOC_Reason"
                  >
                    <h6>
                      {{
                        loanInfoModel.LoanInfo.Is_Noc_Block === 0 ||
                        loanInfoModel.LoanInfo.Is_Noc_Block === null
                          ? "NOC Un-Block"
                          : "NOC Block"
                      }}
                      Remarks
                    </h6>
                    <p>
                      {{ loanInfoModel.LoanInfo.NOC_Reason }}
                    </p>
                  </div>

                  <div class="col-md-3">
                    <button
                      type="button"
                      (click)="nocModel()"
                      mat-raised-button
                      color="primary"
                      *ngIf="
                        loanSummary.LoanNo != null && loanSummary.LoanNo != ''
                      "
                      [class.spinner]="loading"
                      [disabled]="!f.form.valid"
                      style="line-height: 22px !important; font-size: 12px"
                      [style.background-color]="
                        loanInfoModel.LoanInfo.Is_Noc_Block === 0 ||
                        loanInfoModel.LoanInfo.Is_Noc_Block === null
                          ? 'rgba(10, 46, 108, 0.7019607843)'
                          : 'red'
                      "
                    >
                      {{
                        loanInfoModel.LoanInfo.Is_Noc_Block === 0 ||
                        loanInfoModel.LoanInfo.Is_Noc_Block === null
                          ? "Block NOC"
                          : "Un-Block NOC"
                      }}
                    </button>
                  </div>
                  <div
                    class="col-md-3"
                    *ngIf="loanInfoModel.LoanInfo.Is_Noc_Block === 1"
                  >
                    <p style="color: #db1f1f; font-weight: bold">
                      NOC Is Blocked !!!
                    </p>
                  </div>
                </div> -->
              </div>
            </div>

            <!-- Installment Details Card -->
            <div
              class="details-card"
              *ngIf="
                loanSummary.CloseDate == null ||
                loanSummary.CloseDate == '' ||
                loanSummary.CloseDate == undefined
              "
            >
              <div class="card-header-container">
                <h3 class="card-title-text">Installment's Details</h3>
              </div>
              <div class="installment-table-container">
                <table>
                  <thead>
                    <tr class="table-header-row">
                      <th>&nbsp;</th>
                      <th>Total</th>
                      <th>Matured</th>
                      <th>Remaining</th>
                      <th>Received</th>
                      <th>Overdue</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>Nos.</th>
                      <td>{{ EMIDetails != undefined ? EMIDetails.TotalEMI : "" }}</td>
                      <td>{{ EMIDetails != undefined ? EMIDetails.MatureEMI : "" }}</td>
                      <td>{{ EMIDetails != undefined ? EMIDetails.Remaining_EMI : "" }}</td>
                      <td>{{ EMIDetails != undefined ? EMIDetails.Received_EMI : "" }}</td>
                      <td [class.highlight-overdue]="EMIDetails != undefined && (EMIDetails.MatureEMI - EMIDetails.Received_EMI) > 0">
                        {{ EMIDetails != undefined ? EMIDetails.MatureEMI - EMIDetails.Received_EMI : "" }}
                      </td>
                    </tr>
                    <tr>
                      <th>Amount</th>
                      <td>
                        <span *ngIf="EMIDetails != undefined">&#8377; {{ EMIDetails.TotalEMI_Amount }}</span>
                      </td>
                      <td>
                        <span *ngIf="EMIDetails != undefined">&#8377; {{ EMIDetails.MatureEMI_Amount }}</span>
                      </td>
                      <td>
                        <span *ngIf="EMIDetails != undefined">&#8377; {{ EMIDetails.Remaining_EMI_Amount }}</span>
                      </td>
                      <td>
                        <span *ngIf="EMIDetails != undefined">&#8377; {{ EMIDetails.Received_EMI_Amount }}</span>
                      </td>
                      <td [class.highlight-overdue]="EMIDetails != undefined && (EMIDetails.MatureEMI_Amount - EMIDetails.Received_EMI_Amount) > 0">
                        <span *ngIf="EMIDetails != undefined">
                          &#8377; {{ EMIDetails.MatureEMI_Amount - EMIDetails.Received_EMI_Amount }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Collection Details Card -->
            <div class="details-card">
              <div class="card-header-container">
                <h3 class="card-title-text">Collection Details</h3>
              </div>

              <div class="details-grid">
                <div class="details-field">
                  <span class="field-label">Application Date</span>
                  <span class="field-value">
                    {{ loanInfoModel.AppInfo.ApplicationDate | date : "dd/MM/yyyy" }}
                  </span>
                </div>
                <div class="details-field">
                  <span class="field-label">Branch Head</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.BranchHeadName || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Collection Sub Area</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.SubareaName || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">CRC Type</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.CRC_LoanTypeName || '-' }}</span>
                </div>
                <div class="details-field" *ngIf="loanSummary.IsAnyCustomerFirm == 1">
                  <span class="field-label">CRC Type Non-Individual</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.CRC_LoanTypeName_NonIndividual || '-' }}</span>
                </div>

                <!-- Dynamic Source Name -->
                <div
                  class="details-field"
                  *ngIf="
                    loanInfoModel.LoanInfo.SourceType == 'Reference' ||
                    loanInfoModel.LoanInfo.SourceType == 'Social Media'
                  "
                >
                  <span class="field-label">Source Name</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.LeadReference || '-' }}</span>
                </div>
                <div
                  class="details-field"
                  *ngIf="
                    loanInfoModel.LoanInfo.SourceType == 'DSA' ||
                    loanInfoModel.LoanInfo.SourceType == 'Agent' ||
                    loanInfoModel.LoanInfo.SourceType == 'Sales Executive' ||
                    loanInfoModel.LoanInfo.SourceType == 'Dealer' ||
                    loanInfoModel.LoanInfo.SourceType == 'Telecaller Executive' ||
                    loanInfoModel.LoanInfo.SourceType == 'Marketing Executive'
                  "
                >
                  <span class="field-label">Source Name</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.Partner_Name || '-' }}</span>
                </div>

                <div class="details-field">
                  <span class="field-label">Source Area</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.SourceAreaName || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Sales Executive</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.SalesExecutiveName || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Collection Executive</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.CollectionExecutiveName || '-' }}</span>
                </div>
                <div class="details-field">
                  <span class="field-label">Collection Area</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.AreaName || '-' }}</span>
                </div>

                <!-- SUIT FILED STATUS -->
                <div
                  class="details-field"
                  *ngIf="
                    loanInfoModel.LoanInfo.SUITFILEDSTATUS_Name != '' &&
                    loanInfoModel.LoanInfo.SUITFILEDSTATUS_Name != null
                  "
                >
                  <span class="field-label">SUIT FILED STATUS</span>
                  <span class="field-value">{{ loanInfoModel.AppInfo.SUITFILEDSTATUS_Name || '-' }}</span>
                </div>

                <div class="details-field">
                  <span class="field-label">Loan Segment</span>
                  <span class="field-value">{{ loanSegementView || '-' }}</span>
                </div>

                <!-- SMS permission -->
                <div
                  class="details-field"
                  *ngIf="loanSummary.LoanNo != null && loanSummary.LoanNo != ''"
                >
                  <span class="field-label">Sent Text SMS</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.IsSMSAllow ? "Yes" : "No" }}</span>
                </div>

                <!-- CIBIL Permission -->
                <div
                  class="details-field"
                  *ngIf="loanSummary.LoanNo != null && loanSummary.LoanNo != ''"
                >
                  <span class="field-label">Include in CIBIL Report</span>
                  <span class="field-value">{{ loanInfoModel.LoanInfo.IsCibil ? "Yes" : "No" }}</span>
                </div>
              </div>

              <!-- NOC block / alerts -->
              <div class="noc-action-container" *ngIf="loanSummary.LoanNo != null && loanSummary.LoanNo != ''">
                <div>
                  <button
                    type="button"
                    (click)="nocModel()"
                    [class.spinner]="loading"
                    [disabled]="!f.form.valid"
                    class="noc-block-btn"
                    [class.noc]="loanInfoModel.LoanInfo.Is_Noc_Block === 0 || loanInfoModel.LoanInfo.Is_Noc_Block === null"
                    [class.isNOCUnblock]="loanInfoModel.LoanInfo.Is_Noc_Block === 1"
                  >
                    <i class="fa-solid" [class.fa-ban]="loanInfoModel.LoanInfo.Is_Noc_Block === 0 || loanInfoModel.LoanInfo.Is_Noc_Block === null" [class.fa-unlock]="loanInfoModel.LoanInfo.Is_Noc_Block === 1"></i>
                    {{
                      loanInfoModel.LoanInfo.Is_Noc_Block === 0 ||
                      loanInfoModel.LoanInfo.Is_Noc_Block === null
                        ? "Block NOC"
                        : "Un-Block NOC"
                    }}
                  </button>
                </div>
                
                <div *ngIf="loanInfoModel.LoanInfo.Is_Noc_Block === 1" class="noc-blocked-status-alert">
                  <i class="fa-solid fa-circle-exclamation"></i>
                  <span>NOC Is Blocked !!!</span>
                </div>

                <div *ngIf="loanInfoModel.LoanInfo.NOC_Reason" class="details-field" style="margin-left: auto;">
                  <span class="field-label">
                    {{
                      loanInfoModel.LoanInfo.Is_Noc_Block === 0 ||
                      loanInfoModel.LoanInfo.Is_Noc_Block === null
                        ? "NOC Un-Block"
                        : "NOC Block"
                    }}
                    Remarks
                  </span>
                  <span class="field-value" style="color: #64748b;">
                    {{ loanInfoModel.LoanInfo.NOC_Reason }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <hr />
  </form>

  <div class="lms-sticky-actions row m-0 mt-3 col-md-12">
    <div
      class="lms-sticky-actions col-md-12 text-right d-flex align-items-center justify-content-end"
    >
      <button
        type="button"
        (click)="SaveLoanInfo()"
        class="mt-3 btn font-size-12 button-btn"
        [class.spinner]="loading"
        [disabled]="!f.form.valid || showAddCustomerButton"
      >
        Next <i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </div>
</div>
<div
  class="modal fade in"
  id="BasicInfo"
  tabindex="-1"
  role="dialog"
  aria-labelledby="basicInfoModalLabel"
  data-backdrop="false"
>
  <div class="modal-dialog modal-dialog-centered modal-xl mw-950" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header basic-info-modal-header">
        <h6 class="modal-title basic-info-modal-title" id="basicInfoModalLabel">
          <i class="fas fa-file-contract mr-2"></i> Basic Loan Information
        </h6>
        <button type="button" class="close ml-2 basic-info-modal-close" data-dismiss="modal" aria-label="Close" (click)="OnCloseBasicInfo()">
          <span aria-hidden="true"><i class="far fa-times-circle"></i></span>
        </button>
      </div>
      <div class="modal-body basic-info-modal-body" *ngIf="basicLoanInfoData">
        <div class="d-flex flex-column gap-20">
          
          <!-- Loan Details (Item1) -->
          <div class="basic-info-card m-0" *ngIf="basicLoanInfoData.Item1 && basicLoanInfoData.Item1.length > 0">
            <div class="basic-info-card-header">
              <div class="basic-info-icon-box blue">
                <i class="fas fa-file-invoice-dollar"></i>
              </div>
              <div>
                <p class="basic-info-card-title">Loan Details</p>
                <p class="basic-info-card-subtitle">Account & Sanction Info</p>
              </div>
            </div>
            <div class="basic-info-card-body p-4">
              <div class="row m-0">
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Account No.</div><div class="detail-value text-primary">{{ basicLoanInfoData.Item1[0].LoanAcNo || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Type</div><div class="detail-value">{{ basicLoanInfoData.Item1[0].Loan_Type || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Sanctioned</div><div class="detail-value">{{ basicLoanInfoData.Item1[0].Sanctioned_amount ? (basicLoanInfoData.Item1[0].Sanctioned_amount | currency:'INR':'symbol':'1.0-0') : '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Period</div><div class="detail-value">{{ basicLoanInfoData.Item1[0].Loan_Period_Years ? (basicLoanInfoData.Item1[0].Loan_Period_Years + ' Years') : '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">EMI Amount</div><div class="detail-value">{{ basicLoanInfoData.Item1[0].Emi_Amount ? (basicLoanInfoData.Item1[0].Emi_Amount | currency:'INR':'symbol':'1.0-0') : '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Disbursement</div><div class="detail-value">{{ basicLoanInfoData.Item1[0].Disbursement_Date ? (basicLoanInfoData.Item1[0].Disbursement_Date | date:'dd/MM/yyyy') : '-' }}</div></div>
                <div class="col-md-6 mb-3 px-2"><div class="detail-label">Branch</div><div class="detail-value">{{ basicLoanInfoData.Item1[0].Branch_Name || '-' }}</div></div>
                <div class="col-md-12 mb-2 px-2"><div class="detail-label">Address</div><div class="detail-value">{{ basicLoanInfoData.Item1[0].Branch_Address || '-' }}</div></div>
              </div>
            </div>
          </div>

          <!-- Borrower Details (Item2) -->
          <div class="basic-info-card m-0" *ngIf="basicLoanInfoData.Item2 && basicLoanInfoData.Item2.length > 0">
            <div class="basic-info-card-header">
              <div class="basic-info-icon-box green">
                <i class="fas fa-user"></i>
              </div>
              <div>
                <p class="basic-info-card-title">Borrower Details</p>
                <p class="basic-info-card-subtitle">Primary Applicant Info</p>
              </div>
            </div>
            <div class="basic-info-card-body p-4">
              <div class="row m-0">
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Full Name</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_full_name || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">PAN</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_pan || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">DOB</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_dob || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Gender</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_gender || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Mobile</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_mobile || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Email</div><div class="detail-value text-truncate" [attr.title]="currentUser.IsMaskingMobile ? (basicLoanInfoData.Item2[0].borrower_email ? (basicLoanInfoData.Item2[0].borrower_email | emailmask) : '-') : (basicLoanInfoData.Item2[0].borrower_email || '-')"><span *ngIf="currentUser.IsMaskingMobile">{{ basicLoanInfoData.Item2[0].borrower_email ? (basicLoanInfoData.Item2[0].borrower_email | emailmask) : '-' }}</span><span *ngIf="!currentUser.IsMaskingMobile">{{ basicLoanInfoData.Item2[0].borrower_email || '-' }}</span></div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Landmark</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_landmark || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">City</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_city || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">State</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_state || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Pincode</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_pincode || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Occupation Type</div><div class="detail-value text-truncate" title="{{ basicLoanInfoData.Item2[0].borrower_occupation_type }}">{{ basicLoanInfoData.Item2[0].borrower_occupation_type || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Nature of Work</div><div class="detail-value text-truncate" title="{{ basicLoanInfoData.Item2[0].borrower_nature_of_work }}">{{ basicLoanInfoData.Item2[0].borrower_nature_of_work || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Height (cm)</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_height_cm || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Weight (kg)</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_weight_kg || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Road Area</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_road_area || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Address</div><div class="detail-value">{{ basicLoanInfoData.Item2[0].borrower_address_line || '-' }}</div></div>
              </div>
            </div>
          </div>

          <!-- Co-Applicant Details (Item3) -->
          <div class="basic-info-card m-0" *ngIf="hasValidCoApplicant()">
            <div class="basic-info-card-header">
              <div class="basic-info-icon-box warning">
                <i class="fas fa-user-friends"></i>
              </div>
              <div>
                <p class="basic-info-card-title">Co-Applicant Details</p>
                <p class="basic-info-card-subtitle">Secondary Applicant Info</p>
              </div>
            </div>
            <div class="basic-info-card-body p-4">
              <div class="row m-0">
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Full Name</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_full_name || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">PAN</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_pan || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">DOB</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_dob || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Gender</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_gender || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Mobile</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_mobile || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Email</div><div class="detail-value text-truncate" [attr.title]="currentUser.IsMaskingMobile ? (basicLoanInfoData.Item3[0].coapplicant_email ? (basicLoanInfoData.Item3[0].coapplicant_email | emailmask) : '-') : (basicLoanInfoData.Item3[0].coapplicant_email || '-')"><span *ngIf="currentUser.IsMaskingMobile">{{ basicLoanInfoData.Item3[0].coapplicant_email ? (basicLoanInfoData.Item3[0].coapplicant_email | emailmask) : '-' }}</span><span *ngIf="!currentUser.IsMaskingMobile">{{ basicLoanInfoData.Item3[0].coapplicant_email || '-' }}</span></div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Landmark</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_landmark || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">City</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_city || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">State</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_state || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Pincode</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_pincode || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Occupation Type</div><div class="detail-value text-truncate" title="{{ basicLoanInfoData.Item3[0].coapplicant_occupation_type }}">{{ basicLoanInfoData.Item3[0].coapplicant_occupation_type || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Nature of Work</div><div class="detail-value text-truncate" title="{{ basicLoanInfoData.Item3[0].coapplicant_nature_of_work }}">{{ basicLoanInfoData.Item3[0].coapplicant_nature_of_work || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Height (cm)</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_height_cm || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Weight (kg)</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_weight_kg || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Road Area</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_road_area || '-' }}</div></div>
                <div class="col-md-3 mb-3 px-2"><div class="detail-label">Address</div><div class="detail-value">{{ basicLoanInfoData.Item3[0].coapplicant_address_line || '-' }}</div></div>
              </div>
            </div>
          </div>

          <!-- Relation Details (Item4) -->
          <div class="basic-info-card m-0" *ngIf="getRelationsByType('C').length > 0">
            <div class="basic-info-card-header">
              <div class="basic-info-icon-box danger">
                <i class="fas fa-user-shield"></i>
              </div>
              <div>
                <p class="basic-info-card-title">Relation Details</p>
                <p class="basic-info-card-subtitle">Relation Info & Details</p>
              </div>
            </div>
            <div class="basic-info-card-body p-4 max-h-250-auto">
              <div class="mb-3" *ngIf="getRelationsByType('C').length > 0">
                <div class="detail-label mb-2"><span class="relation-type-badge">Co-Borrower ({{ getRelationsByType('C').length }})</span></div>
                <div class="row m-0 co-borrower-row" *ngFor="let relation of getRelationsByType('C'); let isLast = last">
                  <div class="col-lg-3 col-md-3 col-sm-6 mb-2 px-2"><div class="detail-label">Loan Account Number</div><div class="detail-value">{{ relation.Loan_Account_Number || '-' }}</div></div>
                  <div class="col-lg-3 col-md-3 col-sm-6 mb-2 px-2"><div class="detail-label">Name</div><div class="detail-value">{{ relation.Name || '-' }}</div></div>
                  <div class="col-lg-3 col-md-3 col-sm-6 mb-2 px-2"><div class="detail-label">DOB</div><div class="detail-value">{{ relation.DOB || '-' }}</div></div>
                  <div class="col-lg-3 col-md-3 col-sm-6 mb-2 px-2"><div class="detail-label">Relationship</div><div class="detail-value"><span class="badge badge-secondary fw-500">{{ relation.Relationship || '-' }}</span></div></div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="modal-body basic-info-loading" *ngIf="!basicLoanInfoData">
        <i class="fas fa-spinner fa-spin mr-2"></i> Loading information...
      </div>
      <div class="modal-footer basic-info-modal-footer">
        <button
          type="button"
          class="btn font-size-12 button-btn"
          (click)="exportBasicInfoToExcel()"
          [disabled]="!basicLoanInfoData"
        >
          <i class="fas fa-file-excel mr-1"></i> Export Excel
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="proFilePicFull"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header p-10">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Profile Picture
        </h6>
        <button
          type="button"
          (click)="OnCloseProfile()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body">
        <div class="profile-img-container">
          <img
            (click)="ProfilePicFullmodel()"
            class="modal-profile-img"
            src="{{ CustomerPicDetail }}"
            alt="Profile Pic"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="nocBlocked"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header p-10">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          {{
            loanInfoModel.LoanInfo.Is_Noc_Block === 0 ||
            loanInfoModel.LoanInfo.Is_Noc_Block === null
              ? "NOC Block"
              : "NOC Un-Block"
          }}
        </h6>
        <button
          type="button"
          (click)="OnClose()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body">
        <form #ff="ngForm" novalidate>
          <div class="col-md-12 row">
            <div class="col-md-12 p-1">
              <span class="required-lable">Remarks</span>
            </div>
            <div class="col-md-12 p-1 w-100">
              <input
                (keyup)="onKey($event)"
                type="text"
                name="Remarks"
                id=""
                [(ngModel)]="remarksNOC"
                class="form-control input-text-css"
                required
                #refremarksNOC="ngModel"
                placeholder="Remarks"
                [ngClass]="{
                  'is-invalid': ff.submitted && refremarksNOC.invalid,
                  'alert-warning':
                    refremarksNOC.invalid &&
                    (refremarksNOC.dirty ||
                      refremarksNOC.touched ||
                      refremarksNOC.untouched)
                }"
              />
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          (click)="OnSave()"
          [disabled]="!ff.form.valid"
          class="btn font-size-12 button-btn"
          data-dismiss="modal"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="dataCustomerSource && dataCustomerSource.length > 0" class="row m-0 mt-3">
  <div class="col-md-12 p-1">
    <div class="table-responsive">
      <mat-table [dataSource]="dataCustomerSource">
        <ng-container matColumnDef="Number">
          <mat-header-cell
            class="grid-header mw50"
            *matHeaderCellDef
            >#</mat-header-cell
          >
          <mat-cell
            *matCellDef="let row; let i = index"
            class="grid-cell mw50 mh-5"
          >
            {{ i + 1 }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="CustomerId" class="d-none">
          <mat-header-cell
            class="grid-header mw100 mh-5 d-none"
            *matHeaderCellDef
          >
            CustomerId
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            class="grid-cell mw100 mh-5 d-none"
          >
            {{ row.CustomerId }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="CustomerName">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Customer
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.CustomerName }}
          </mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="CustomerType">
              <mat-header-cell class="grid-header" *matHeaderCellDef>Customer Type</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{
                row.CustomerType == "Hirer" ? "Borrower" : row.CustomerType
                }}
              </mat-cell>
            </ng-container> -->

        <ng-container matColumnDef="GenderAge">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Gender/Age
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Gender }} / {{ row.Age }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="PhoneNo">
          <mat-header-cell class="grid-header" *matHeaderCellDef
            >Phone No</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            <div *ngIf="currentUser.IsMaskingMobile">
              {{ row.PhoneNo | mask }}
            </div>
            <div *ngIf="!currentUser.IsMaskingMobile">
              {{ row.PhoneNo }}
            </div>
            <!-- <i *ngIf="row.PhoneNoIsVerified.toLowerCase() == 'true'" class="fa fa-check-circle ml-2"
                  style="color: green"></i> -->
          </mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="Relation_With_Hirer">
              <mat-header-cell class="grid-header" *matHeaderCellDef>
                Relation With Borrower
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{
                row.Relation_With_Hirer == "Own" ||
                row.Relation_With_Hirer == "OWN"
                ? "Self"
                : row.Relation_With_Hirer
                }}
              </mat-cell>
            </ng-container> -->
        <ng-container matColumnDef="RelationName">
          <mat-header-cell class="grid-header" *matHeaderCellDef
            >Relation</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.RelationName }}
          </mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="ExistingCustomer">
              <mat-header-cell class="grid-header" *matHeaderCellDef>
                Existing
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.ExistingCustomer }}
              </mat-cell>
            </ng-container> -->
        <mat-header-row
          *matHeaderRowDef="displayedCustomerColumns"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedCustomerColumns"
        ></mat-row>
      </mat-table>
    </div>
  </div>
</div>
<app-digilocker-sdk
  #digilockerSdk1
  [openmodel]="openmodel"
  (close)="onsdkSuccess($event)"
>
  <div>sdk added to customer entry 1</div>
</app-digilocker-sdk>

<app-digiosdk #digioSdk [digioresponse]="digioresponse" (close)="ondigioSDKSuccess($event)"></app-digiosdk>
